import { useAppContext } from "./useAppContext";

export const useEditor = () => {
	const { editor } = useAppContext();

	return editor;
};
